import React, { ReactNode, useState } from 'react'
import { t } from 'i18next'
import { Whisper, Popover, IconButton, Message } from 'rsuite'
import { InfoRound } from '@rsuite/icons'
import CloseIcon from '@rsuite/icons/Close'

// Placement comes from Whisper rather than rsuite's internal types path, which
// no longer exports TypeAttributes — and is not public API in any case.
type Placement = NonNullable<React.ComponentProps<typeof Whisper>['placement']>

const InfoMessage: React.FC<{ children: ReactNode, placement?: Placement }> = ({ placement = 'right', children }) => {
    const Overlay = React.forwardRef(({ style, onClose, ...rest }: any, ref) => {
        const className = rest.className + " info-message"
        return (
            <Popover ref={ref} {...rest} className={className}>
                {/*
                  * The close button is pinned to the corner rather than placed
                  * beside the text. As a flex sibling with marginLeft:auto it was
                  * pushed along by the content and ended up outside the popover
                  * once the text wrapped — which is every real message.
                  *
                  * The padding on the right keeps the text from running under it.
                  */}
                <div style={{ position: 'relative', paddingRight: '1.75rem', maxWidth: '22rem' }}>
                    {children}
                    <IconButton
                        size="xs"
                        icon={<CloseIcon />}
                        onClick={onClose}
                        appearance="subtle"
                        aria-label={t('Close')}
                        style={{ position: 'absolute', top: 0, right: 0 }}
                    />
                </div>
            </Popover>
        )
    })

    return (
        <Whisper
            className="info-message-container"
            trigger="click"
            placement={placement}
            speaker={(props, ref) => {
                const { className, left, top, onClose } = props
                return <Overlay style={{ left, top }} onClose={onClose} className={className} ref={ref} />
            }}
        >
            <IconButton icon={<InfoRound />} appearance="link" className="info-message-button" />
        </Whisper>
    )
}

export default InfoMessage